module.exports = __webpack_public_path__ + "static/mascon_head_blink-1e01799a5d3d77bef1c2ad51210f4eef.gif";